import { combineReducers } from "redux";

// Reducers:
import globalAppReducer from "./modules/globalModule";
import tenantModule from "./modules/tenantModule";
import errorFieldModule from "./modules/errorFieldModule";
import exploreModule from "../../pages/Explore/exploreModule";
import offerDetailsModule from "../../pages/Explore/OfferDetails/offerDetailsModule";
import bookingModule from "../../pages/Booking/bookingModule";
import paymentModule from "./modules/paymentModule";
import bookingConfirmationModule from "./modules/bookingConfirmationModule";
import sbbModule from "../../pages/PublicTransport/Sbb/sbbModule";
import swissTravelPassModule from "../../pages/PublicTransport/Sbb/SwissTravelPass/swissTravelPassModule";
import munichCityPassModule from "../../pages/PublicTransport/MunichCityPass/munichCityPassModule";
import frankfurtCardModule from "../../pages/PublicTransport/FrankfurtCard/frankfurtCardModule";
import googleSearchModule from "./modules/googleSearchModule";
import uberModule from "../../pages/PublicTransport/Uber/uberModule";
import airportTaxiModule from "../../pages/PublicTransport/AirportTaxi/airportTaxiModule";
import europcarModule from "../../pages/PublicTransport/Europcar/europcarModule";
import airlineModule from "../../pages/AirlineLanding/airlineModule";
import limos4Module from "../../pages/PublicTransport/Limos4/limos4Module";
import catModule from "../../pages/PublicTransport/Cat/catModule";
import obbModule from "../../pages/PublicTransport/Obb/obbModule";
import airportBusModule from "../../pages/PublicTransport/AirportBus/airportBusModule";
import deutscheBahnModule from "../../pages/PublicTransport/DeutscheBahn/deutscheBahnModule";

const rootReducer = combineReducers({
  global: globalAppReducer,
  tenant: tenantModule,
  errorField: errorFieldModule,
  explore: exploreModule,
  offerDetails: offerDetailsModule,
  booking: bookingModule,
  payment: paymentModule,
  confirmation: bookingConfirmationModule,
  sbb: sbbModule,
  swissTravelPass: swissTravelPassModule,
  munichCityPass: munichCityPassModule,
  frankfurtCard: frankfurtCardModule,
  googleSearch: googleSearchModule,
  uber: uberModule,
  airportTaxi: airportTaxiModule,
  europcar: europcarModule,
  limos4: limos4Module,
  cat: catModule,
  obb: obbModule,
  airportBus: airportBusModule,
  deutscheBahn: deutscheBahnModule,
  airline: airlineModule
});

export default rootReducer;
